import { Injectable } from "@angular/core";

import { SocketService } from "../socket.service";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";
import { AssetService } from "./asset.service";
import { Metal } from "@models/asset/metal/metal";
import { InitService } from "@core-services/init.service";
import { debug } from "@helpers/debug";

@Injectable({
	providedIn: "root"
})
export class MetalService extends AssetService<Metal> {
	public constructor(
		protected initService: InitService,
		protected socketService: SocketService,
		protected translationService: TranslationService,
		protected destructor: DestructorService
	) {
		super(initService, destructor, translationService, socketService, "MetalService");
	}

	public logoUrl(item: Metal, grayVersion: boolean = false): string {
		let url = "assets/images/logos/";

		if (grayVersion) {
			url += "metals/" + item.getSymbol(true) + "-grey-half-transparent";
		} else {
			url += "metals/metals-" + item.getSymbol(true);
		}

		return url;
	}

	public startSockets(): void {
		if (debug) {
			console.log("[DEBUG]: listen to commodity updates");
		}

		const priceRoom = {
			room: "commodity_prices",
			collection: "commodities",
			type: Metal,
			isPrivate: false
		};
		const assetRoom = {
			room: "commodities",
			collection: "commodities",
			type: Metal,
			isPrivate: false
		};
		this.initSockets(priceRoom, assetRoom);
	}
}
